import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
//import GridLayout from "react-grid-layout";
//import "react-grid-layout/css/styles.css";
//import "react-resizable/css/styles.css";
import { SecretariatShortCutWidget } from './Widgets/SecretariatShortCutWidget';
import { FastAccessWidget } from './Widgets/FastAccessWidget';
import { BulletinWidget } from './Widgets/BulletinWidget';
import Bulletin from './Bulletins/Bulletin';
import { FinanceMonthlyStatsWidget } from './Widgets/FinanceMonthlyStatsWidget';
import { ChequeShortCutWidget } from './Widgets/ChequeShortCutWidget';
import { ChequesListWidget } from './Widgets/ChequesListWidget';
import { DailyExpiredFactorListWidget } from './Widgets/DailyExpiredFactorListWidget';
//import { Responsive, WidthProvider } from "react-grid-layout";
import { ChromePicker } from 'react-color';

//const ResponsiveGridLayout = WidthProvider(Responsive);

export class Home extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            layout: [],
            activeWidgets: [],
            openWidgetModal: false,
            widgetIdToEdit: null
        }
        this.state.Widgets = [
            {
                id: "SecretariatShortCut",
                title: "دسترسی سریع اتوماسیون اداری",
                component: () => <SecretariatShortCutWidget Caller={this} />
            },
            {
                id: "FastAccess",
                title: "دسترسی سریع بخش ها",
                component: () => <FastAccessWidget Caller={this} />
            },
            {
                id: "Bulletin",
                title: "اطلاع رسانی های بولتن من",
                component: () => <BulletinWidget Caller={this} />
            },
            {
                id: "FinanceMonthlyStats",
                title: "نمودار عملکرد ماهانه",
                component: () => <FinanceMonthlyStatsWidget Caller={this} />
            },
            {
                id: "ChequeShortCut",
                title: "دسترسی سریع چکها",
                component: () => <ChequeShortCutWidget Caller={this} />
            },
            {
                id: "ChequesList",
                title: "لیست چکهای درجریان",
                component: () => <ChequesListWidget Caller={this} />
            },
            {
                id: "DailyExpiredFactorList",
                title: "لیست فاکتورهای سررسیده",
                component: () => <DailyExpiredFactorListWidget Caller={this} />
            },
        ];
        //this.onLayoutChange = this.onLayoutChange.bind(this);
        this.toggleWidget = this.toggleWidget.bind(this);
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                        layout: JSON.parse(data.layout),
                        activeWidgets: data.activeWidgets
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    //onLayoutChange(newLayout) {
    //    this.setState({ layout: newLayout });
    //}
    toggleWidget(id) {
        const { activeWidgets } = this.state;
        if (activeWidgets.includes(id)) {
            this.state.activeWidgets = activeWidgets.filter(w => w !== id);
            //this.setState({
            //    activeWidgets: activeWidgets.filter(w => w !== id)
            //});
        } else {
            this.state.activeWidgets = [...activeWidgets, id];
            //this.setState({
            //    activeWidgets: [...activeWidgets, id]
            //});
        }
        this.saveLayout();
    }
    onUserChange = (layout) => {
        this.state.layout = layout;
        //this.setState({ layout });
        this.saveLayout(layout);
    }
    saveLayout() {
        this.httpPost("api/v1/dashboard/layout/save", {
            layout: JSON.stringify(this.state.layout),
            activeWidgets: this.state.activeWidgets,
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderWidget(widgetId) {
        const w = this.state.Widgets.find(x => x.id === widgetId);
        return w ? w.component() : null;
    }
    renderWidgetModal() {
        if (!this.state.openWidgetModal) return null;

        //const { layout, activeWidgets } = this.state;

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.setState({ openWidgetModal: false })}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.setState({ openWidgetModal: false })} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">مدیریت ابزارهای داشبرد شخصی</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    {this.state.Widgets.map(w => <div className="col-lg-4 mt-2" key={w.id}>
                                        <button className={!this.state.activeWidgets.includes(w.id) ? "btn btn-success" : "btn btn-danger"} onClick={() => this.toggleWidget(w.id)}>
                                            {this.state.activeWidgets.includes(w.id) ? "حذف" : "افزودن"} ابزار {w.title}
                                        </button>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.setState({ openWidgetModal: false })}>انصراف</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    getBlankLayout(widgetId) {
        return {
            widgetId: widgetId,
            order: '',
            colCount: '6',
            title: '',
        }
    }
    setLayoutValue(field, value) {
        var find = false;
        this.state.layout.forEach(f => {
            if (f.widgetId === this.state.widgetIdToEdit) {
                f[field] = value;
                find = true;
            }
        });
        if (!find) {
            var lyt = this.getBlankLayout(this.state.widgetIdToEdit);
            lyt[field] = value;
            this.state.layout.push(lyt);
        }
        this.onUserChange(this.state.layout);
    }
    getLayoutValue(field, widgetId) {
        var v = '';
        this.state.layout.forEach(f => {
            if (f.i === widgetId) v = f[field];
        });
        return v;
    }
    renderWidgetConfigModal() {
        if (this.state.widgetIdToEdit === null) return null;

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.setState({ widgetIdToEdit: false })}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.setState({ widgetIdToEdit: false })} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">تنظیمات ابزار</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label className="title1">عنوان</label>
                                            <input defaultValue={this.getLayoutValue('title', this.state.widgetIdToEdit)} onChange={e => this.setLayoutValue('title', e.target.value)} className="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label className="title1">عرض نمایش</label>
                                            <select defaultValue={this.getLayoutValue('colCount', this.state.widgetIdToEdit)} onChange={e => this.setLayoutValue('colCount', e.target.value)} className="form-control input-sm">
                                                <option value="6">نصف صفحه</option>
                                                <option value="12">عرض کامل</option>
                                                <option value="3">1/3 صفحه</option>
                                                <option value="4">1/4 صفحه</option>
                                                <option value="6">1/6 صفحه</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label className="title1">اولویت نمایش</label>
                                            <input defaultValue={this.getLayoutValue('order', this.state.widgetIdToEdit)} onChange={e => this.setLayoutValue('order', e.target.value)} className="form-control" type="text" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">رنگ زمینه کارت</label>
                                            <ChromePicker color={this.getLayoutValue('bgColor', this.state.widgetIdToEdit)} onChangeComplete={e => this.setLayoutValue('bgColor', e.hex)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" onClick={e => this.setState({ widgetIdToEdit: null })}>بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    showBulletin(id) {
        this.showComponents({ component: <Bulletin ReadOnly={true} Caller={this} Id={id} /> });
    }
    renderWidgets() {
        var widgets = [];
        this.state.activeWidgets.forEach(widgetId => {
            widgets.push({
                widgetId: widgetId,
                order: this.getLayoutValue('order', widgetId),
                colCount: this.getLayoutValue('colCount', widgetId),
                title: this.getLayoutValue('title', widgetId),
                bgColor: this.getLayoutValue('bgColor', widgetId)
            });
        });
        var r = [];
        widgets.sort((a, b) => a.order - b.order).forEach(wg => {
            var colCount = '6';
            var bgColor = 'white';
            if (wg.colCount !== '') colCount = wg.colCount;
            if (wg.bgColor !== '') bgColor = wg.bgColor;

            r.push(<div className={"col-lg-" + colCount} key={wg.widgetId} >
                <div className="widget-card" style={{ backgroundColor: bgColor}}>
                    <div className="widget-toolbar">
                        <a className="hand" title="حذف ابزار" onClick={e => this.toggleWidget(wg.widgetId)}><i className="fa fa-trash"></i></a>
                        <a className="hand" title="تنظیمات ابزار" onClick={e => this.setState({ widgetIdToEdit: wg.widgetId })}><i className="fa fa-cog"></i></a>
                        <span>{wg.title}</span>
                    </div>
                    {this.renderWidget(wg.widgetId)}
                </div>
            </div>);
        });
        return r;
    }
    renderForm() {
        //const { layout, activeWidgets } = this.state;

        const widgetsStyles = (
            <style>{`
                .widgets-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0;
                    margin: 10px -15px;
                }
                .widget-card {
                    background: #fff;
                    border-radius: 10px;
                    box-shadow: 0 2px 16px 0 rgba(60,60,60,0.09);
                    padding: 12px;
                    display: flex;
                    flex-direction: column;
                    min-height: 100px;
                    transition: box-shadow 0.2s;
                    border: 1.5px solid #f1f1f2;
                    box-sizing: border-box;
                    margin-left: 15px;
                    height: 100%;
                }
                .widget-card:hover {
                    box-shadow: 0 6px 24px 0 rgba(60,60,60,0.13);
                }
                .widget-toolbar{
                    display: flex;
                    gap: 5px;
                }
                .widget-toolbar span{
                    font-size: 0.9rem;
                    font-weight: 700;
                    color: #222;
                    margin-bottom: 8px;
                    text-align: center;
                }
                @media (max-width: 700px) {
                    .widgets-grid {
                        display: flex;
                        flex-direction: column;
                        gap: 18px;
                    }
                }
            `}</style>
        );

        return <div className="nk-content-body">
            {this.renderWidgetModal()}
            {this.renderWidgetConfigModal() }
            {widgetsStyles}
            {!this.isNull(this.state.data.global.company) && <div className="nk-block">
                <div className="widgets-grid">
                    {this.renderWidgets() }
                    <div className="col-lg-12"></div>
                    <div className="col-lg-4"></div>
                    <div className="col-lg-4" onClick={e => this.setState({ openWidgetModal: true })}>
                        <div className="widget-card" style={{
                            textAlign: 'center',
                            minHeight: 120,
                            justifyContent: 'center',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 10,
                            border: '1px dashed #4651E1',
                            borderRadius: 10,
                            padding: 10,
                            margin: 10,
                            boxShadow: '0 2px 8px 0 rgba(60,60,60,0.07)',
                            transition: 'box-shadow 0.2s',
                            '&:hover': {
                                boxShadow: '0 6px 24px 0 rgba(60,60,60,0.13)',
                                borderColor: '#4651E1',
                            },
                            '&:active': {
                                boxShadow: '0 2px 8px 0 rgba(60,60,60,0.07)',
                                borderColor: '#4651E1',
                            },
                        }}>
                            <em className="fa fa-plus" style={{ fontSize: '2rem' }}></em>
                            <span style={{ fontSize: '0.9rem' }}>افزودن ابزار جدید</span>
                        </div>
                    </div>
                </div>
            </div>}


            {/*{!this.isNull(this.state.data.global.company) && <div>*/}

            {/*    <div className="container userDashboadrLayout" style={{ position: "relative" }}>*/}
            {/*        <ResponsiveGridLayout*/}
            {/*            className="layout"*/}
            {/*            layouts={layout}*/}
            {/*            breakpoints={{ lg: 1024, md: 996, sm: 768, xs: 320, xxs: 0 }}*/}
            {/*            cols={{ lg: 12, md: 6, sm: 1, xs: 1, xxs: 1 }}*/}
            {/*            rowHeight={1}*/}
            {/*            margin={[0, 0]}*/}
            {/*            draggableCancel=".no-drag-widget"*/}
            {/*            onLayoutChange={this.onLayoutChange}*/}
            {/*            onDragStop={this.onUserChange}*/}
            {/*            onResizeStop={this.onUserChange}*/}
            {/*        >*/}
            {/*            {activeWidgets.map(widgetId => {*/}
            {/*                var defaultLayout = { x: 0, y: 0, w: 12, h: 200, i: widgetId };*/}
            {/*                if (widgetId === 'Bulletin') {*/}
            {/*                    defaultLayout.w = 6;*/}
            {/*                    defaultLayout.h = 350;*/}
            {/*                }*/}
            {/*                if (widgetId === 'SecretariatShortCut') defaultLayout.h = 150;*/}
            {/*                if (widgetId === 'FastAccess') defaultLayout.h = 430;*/}
            {/*                if (widgetId === 'FinanceMonthlyStats') defaultLayout.h = 430;*/}

            {/*                const defaultGrid = layout.find(l => l.i === widgetId) || defaultLayout;*/}
            {/*                return (*/}
            {/*                    <div key={widgetId} data-grid={defaultGrid} className="widgetContainer">*/}
            {/*                        <section className="inner">*/}
            {/*                            {this.renderWidget(widgetId)}*/}
            {/*                        </section>*/}
            {/*                    </div>*/}
            {/*                );*/}
            {/*            })}*/}
            {/*        </ResponsiveGridLayout>*/}
            {/*    </div>*/}

            {/*    <div id="HomeWidgetDesigerLink" className="text-center">*/}
            {/*        <a className="btn btn-btn btn-warning" onClick={e => this.setState({ openWidgetModal: true })}>مدیریت ابزارهای داشبرد</a>*/}
            {/*    </div>*/}
            {/*</div>}*/}
        </div>

    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}